/**
 * @generated SignedSource<<99dcf6616152b17250952cff60ca904d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MessageBannerCarousel_viewer$data = {
  readonly activePromotion: {
    readonly " $fragmentSpreads": FragmentRefs<"messageHelpers_promotion">;
  } | null;
  readonly expiringPromotion: {
    readonly " $fragmentSpreads": FragmentRefs<"messageHelpers_expiringPromotion">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"messageHelpers_viewer">;
  readonly " $fragmentType": "MessageBannerCarousel_viewer";
};
export type MessageBannerCarousel_viewer$key = {
  readonly " $data"?: MessageBannerCarousel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"MessageBannerCarousel_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MessageBannerCarousel_viewer",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "messageHelpers_viewer",
      "selections": [
        {
          "alias": "promoCodeMessaging",
          "args": [
            {
              "kind": "Literal",
              "name": "feature",
              "value": "promoCodeMessaging"
            }
          ],
          "kind": "ScalarField",
          "name": "featureFlag",
          "storageKey": "featureFlag(feature:\"promoCodeMessaging\")"
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "Promotion",
      "kind": "LinkedField",
      "name": "activePromotion",
      "plural": false,
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "messageHelpers_promotion",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "buyerDisplayable",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FlatAdjustmentRate",
              "kind": "LinkedField",
              "name": "flatAdjustmentRate",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ConvertedAmountList",
                      "kind": "LinkedField",
                      "name": "convertedAmountList",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "amount",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currency",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PromotionMeta",
              "kind": "LinkedField",
              "name": "promotionMeta",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customBannerMessage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "desktopBannerMessage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "desktopBannerCta",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "mobileBannerMessage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "mobileBannerCta",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "Promotion",
      "kind": "LinkedField",
      "name": "expiringPromotion",
      "plural": false,
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "messageHelpers_expiringPromotion",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ExpiringPromoMessage_promotion"
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "expiringPromoMessageHelpers_expiringPromotion",
              "selections": [
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "truncate",
                      "value": false
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "daysRelativeToExpiration",
                  "storageKey": "daysRelativeToExpiration(truncate:false)"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PromotionMeta",
                  "kind": "LinkedField",
                  "name": "promotionMeta",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "urgencyMessagingDisplay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "urgencyMessagingDaysBeforeExpiration",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "args": null,
              "argumentDefinitions": []
            }
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "163fa9d8eec2feddcc736d470cd5d5ef";

export default node;
